import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { Login } from 'pds-witsmlstudio-core/components';
import PageLayout from '../components/page-layout';

<template>
  {{pageTitle (t "login.title")}}

  <PageLayout>
    <:content>
      <div class="pds-witsmlstudio-backdrop opacity-60" />
      <Login />
    </:content>
  </PageLayout>
</template>
